import { EmployeeList } from 'ui/components/3-organisms/EmployeeList/EmployeeList';

export const EmployeeListFeature: React.FC<Content.EmployeeList> = ({ content }) => {
	const { employees } = content?.properties ?? {};

	return (
		<EmployeeList
			heading={content?.properties?.heading}
			subHeading={content?.properties?.subHeading}
			employees={
				employees?.length &&
				employees.map(({ id, properties: { fullName, workTitle, email, linkedIn, image, phoneNumber } }) => {
					return {
						id,
						image: {
							url: image?.url,
							altText: image?.properties?.altText,
							focalPoint: image?.focalPoint,
						},
						name: fullName,
						role: workTitle,
						linkedIn,
						email,
						phoneNumber,
					};
				})
			}
			showMoreButton={content?.properties?.showMoreButton}
			showMoreAmount={content?.properties?.showMoreAmount}
			bgColor={content?.properties?.color}
		/>
	);
};
